module.exports = __webpack_public_path__ + "img/1.8f5ae8d4.png";